<div class="prima-starch">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12 my-md-5 mb-5 sec-title">
                <app-title-page [dataTitle]="dataTitle" [link]="'#prod-prima'"></app-title-page>
            </div>
            <!-- contents -->
            <div class="col-md-12 sec-contents" id="prod-prima">
                <div class="lane-top pt-5">
                    <div class="desc text-justify" [innerHTML]="dataSection[0]?.content"></div>
                    <!-- logo prima -->
                    <div class="logo-products mt-4 mb-5" *ngIf="dataSection[0]?.card[0].length != 0">
                        <div class="row px-md-0 px-2">
                            <div class="col-4 px-md-3 px-1 color text-center" *ngFor="let prima of dataSection[0]?.card">
                                <div class="bg-prima">
                                    <img [src]="apiAsset + prima.picture" alt="">
                                </div>
                                <div class="ket mt-md-4 mt-3">
                                    <h6 class="tit-f18s mb-2">{{ prima.title }}</h6>
                                    <div [innerHTML]="prima.description"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- sertifikat halal -->
                    <div class="sertifikat">
                        <div class="row">
                            <div class="col-lg-4 col-md-5 col-8 mx-auto">
                                <img class="w-100" [src]="apiAsset + dataSection[1]?.card[0].picture" alt="">
                            </div>
                        </div>
                        <div class="desc mt-4 text-justify" [innerHTML]="dataSection[1]?.content"></div>
                    </div>
                     <!-- table parameter -->
                    <div class="table-analysis my-5">
                        <h3 class="f-subtit">{{ dataSection[2]?.title }}</h3>
                        <div class="desc text-justify grey mt-4" [innerHTML]="dataSection[2]?.content"></div>
                    </div>
                    <!-- table comporation -->
                    <div class="table-comparation">
                        <h3 class="f-subtit">{{ dataSection[3]?.title }}</h3>
                        <div class="desc text-justify grey mt-4" [innerHTML]="dataSection[3]?.content"></div>
                    </div>
                    <!-- bagan prima product -->
                    <div class="bagan-prima mt-5"> 
                        <h3 class="f-subtit">{{ dataSection[4]?.title }}</h3>
                        <div class="col-md-11 my-4 mt-md-0 mx-auto">
                             <!-- <div class="row">
                                <div class="col-md-3 col-sm-6 col-7 mx-auto">
                                    <div class="pict px-3 pb-md-5 pb-4">
                                        <img [src]="apiAsset + dataSection[4]?.card[0].picture" class="w-100" alt="">
                                    </div>
                                </div>
                                <div class="col-md-10 px-4 mx-auto d-md-block d-none">
                                    <div class="circle-red"></div>
                                    <div class="border-up"></div>
                                    <hr class="border-down">
                                </div>
                                <div class="row food px-md-0 px-2">
                                    <div class="col-md-3 px-md-3 col-6 px-2" *ngFor="let prod of dataSection[4]?.card | slice:1:5">
                                        <div class="circle-red"></div>
                                        <div class="text-center">
                                            <div class="pict pt-xl-4 pt-md-3 mt-md-0 pt-4 mt-3 pb-2">
                                                <img [src]="apiAsset + prod.picture" class="w-100" alt="">
                                            </div>
                                            <div class="ket pl-4">
                                                <h6>{{ prod.title }}</h6>
                                                <div class="mb-md-0 my-3" [innerHTML]="prod.description"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <!-- english -->
                            <ng-container *ngIf="lang == 'en'">
                                <!-- desktop -->
                                <img class="d-md-block d-none w-100" [src]="apiAsset + dataSection[4]?.card[0].picture" alt="">
                                <!-- mobile -->
                                <img class="d-md-none d-block w-100" [src]="apiAsset + dataSection[4]?.card[2].picture" alt="">
                            </ng-container>
                            <!-- indonesia -->
                            <ng-container *ngIf="lang == 'id'">
                                <!-- desktop -->
                                <img class="d-md-block d-none w-100" [src]="apiAsset + dataSection[4]?.card[1].picture" alt="">
                                <!-- mobile -->
                                <img class="d-md-none d-block w-100" [src]="apiAsset + dataSection[4]?.card[3].picture" alt="">
                            </ng-container>
                        </div>
                        <div class="desc text-justify" [innerHTML]="dataSection[4]?.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</div>


